import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border p-4 rounded-lg flex items-center bg-blue-050 border-blue-200" }
const _hoisted_2 = ["data-testid", "data-test-value", "textContent"]
const _hoisted_3 = ["textContent"]

import Icon from "../Icon/Icon.vue";

interface Props {
  title?: string;
  subtitle?: string;
  testId?: string;
  testValue?: string;
  closable?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
    title: {},
    subtitle: {},
    testId: {},
    testValue: {},
    closable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Icon, {
      name: "toastInfo",
      class: "mr-2 text-blue-600"
    }),
    (props.title)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "font-bold mr-auto",
          "data-testid": props.testId,
          "data-test-value": props.testValue,
          textContent: _toDisplayString(props.title)
        }, null, 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    (props.subtitle)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: "text-sm",
          textContent: _toDisplayString(props.subtitle)
        }, null, 8 /* PROPS */, _hoisted_3))
      : _createCommentVNode("v-if", true),
    (props.closable)
      ? (_openBlock(), _createBlock(Icon, {
          key: 2,
          name: "toastClose"
        }))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})